import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetTicketInput } from '../domain/dtos/get-ticket-input.dto'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { CohortDto } from '@hub-la/sdk-bff-product'

export class GetTicket {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<CohortDto>,
  ) {}

  public async execute(input?: GetTicketInput, signal?: AbortSignal): Promise<CohortDto | undefined> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input?.productId}/cohorts/${input?.ticketId}`,
      signal,
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response?.data
    }

    throw new GeneralError()
  }
}
